import clsx from 'clsx';

import { Card } from '../Card';

import { CTAGroupButton } from './CTAGroupButton';

import type { ButtonProps } from '../Button';
import type { CardProps } from '../Card';
import type { CTAGroupItemProps } from './CTAGroupButton';

import s from './CTAGroup.module.css';

type CTAGroupItems = CTAGroupItemProps[];

export type CTAGroupProps = Omit<CardProps, 'children'> & {
  items: CTAGroupItems;
  fullWidth?: boolean;
  size?: ButtonProps['size'];
};

export const CTAGroup = ({ className, fullWidth, items, size, ...props }: CTAGroupProps) => (
  <Card className={clsx(s.container, className)} role="group" {...props} {...props}>
    {items.map((itemProps, index) => (
      <CTAGroupButton key={index} fullWidth={fullWidth} size={size} {...itemProps} />
    ))}
  </Card>
);
